import { render, staticRenderFns } from "./SflowConfigModal.vue?vue&type=template&id=319f4458&"
import script from "./SflowConfigModal.vue?vue&type=script&lang=js&"
export * from "./SflowConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports